export default __webpack_public_path__ + "static/media/icon-facebook.f013d57a.svg";